import * as React from 'react'
import StandardInput from '../components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../components/recaptcha'
import CheckboxInput from '../components/checkbox-input'
import StepTitle from '../components/step-title'
import SubHeader from '../components/sub-header'
import StepBlock from '../components/step-block'
import Button from '../components/button'
import { condition } from '../../common/util'
import { withNavigation } from '../modules/navigation'
import { withRouteBlocker } from '../modules/route-blocker'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { withProductData } from '../../common/modules/product-data';


@withNavigation
@withRouteBlocker
@withScrollToTop
@withProductData
class Payment extends React.Component<any, any>{

    render(){
        const productData = this.props.productData
        return (
            <div className="row">
                <StepTitle>How would you like to pay</StepTitle>
                <StepBlock>
                    <p>Please select how you would like to pay from the options below.</p>
                </StepBlock>

                <Button.PaymentButtons />
            </div>
        )
    }

}


export default Payment;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/routes/payment.tsx